<template>
	<div id="lang-login" class="position-box-lang">
	 <template v-for="(value, index) in allLang">
     <img class="img-language position-flag cursor-pointer" :src="require('../../assets/img/login/flag_' + focusLang(value) + '.png')" v-on:click="setLang(value)">
	 </template>
	</div>
</template>

<script>
export default {
  name: 'lang-login',
  props: [ 'nowLang', 'allLang', 'focusLang', 'setLang' ]
}
</script>


// WEBPACK FOOTER //
// langLogin.vue?bbfa3768